import { FirebaseApp } from '@angular/fire/app';
import {
  AppCheck,
  ReCaptchaEnterpriseProvider,
  ReCaptchaV3Provider,
  initializeAppCheck,
} from '@angular/fire/app-check';

export function getAppCheck(
  siteKey: string,
  isTokenAutoRefreshEnabled: boolean,
  providertype: 'v3' | 'Entrprise' = 'Entrprise',
  firebaseApp?: FirebaseApp,
): AppCheck {
  const provider =
    providertype === 'Entrprise' ? new ReCaptchaEnterpriseProvider(siteKey) : new ReCaptchaV3Provider(siteKey);
  return initializeAppCheck(firebaseApp, { provider, isTokenAutoRefreshEnabled });
}
